// extracted by mini-css-extract-plugin
module.exports = {"scroll":"_1Gz7ySbf","dummy":"_136896yf","angle":"SlQr_Izc","angleLeft":"_399mm9-p","angleRight":"olYgiAzG"};